import React, { useMemo } from "react";
import { WeatherData } from "../../../../../../store/reducers/weather";
import { PlanFactDetalization } from "../../../../../../store/reducers/dashboard/works/detalization";
import { getWeatherLabels } from "@pages/dashboard/works/detalization/dynamics/DynamicsChart/utils/weather";
import CumulativeChart from "@pages/dashboard/works/detalization/dynamics/DynamicsChart/charts/CumulativeChart/CumulativeChart";
import DifferentiatedChart from "@pages/dashboard/works/detalization/dynamics/DynamicsChart/charts/DifferentiatedChart/DifferentiatedChart";
import { isEmpty } from "lodash";
import st from './DynamicsChart.module.scss';
import PlanFactLegend from "@elements/planFactLegend/PlanFactLegend";

type DynamicsChartProps = {
    isFull: boolean
    isCumulative: boolean
    weather?: WeatherData[]
    planFactDetalization: PlanFactDetalization
}

const DynamicsChart = (props: DynamicsChartProps) => {
    const {
        isFull,
        isCumulative,
        weather: weatherByPeriod,
        planFactDetalization
    } = props;

    const weatherAxis = useMemo(() => {
        return getWeatherLabels(weatherByPeriod);
    }, [weatherByPeriod])

    if (isEmpty(planFactDetalization.fact) && isEmpty(planFactDetalization.plan)) {
        return (
            <div className={st['empty']}>
                <span className={st['empty__text']}>Нет данных. Выберите другой период.</span>
            </div>
        )
    }

    return (
        <div className={st['wrapper']}>
            {isCumulative
                ? <CumulativeChart
                    isFull={isFull}
                    planFactDetalization={planFactDetalization}
                    weatherAxis={weatherAxis}
                />
                : <DifferentiatedChart
                    isFull={isFull}
                    planFactDetalization={planFactDetalization}
                    weatherAxis={weatherAxis}
                    weatherByPeriod={weatherByPeriod}
                />}
            <PlanFactLegend padding={{ right: 10 }} unselectable />
        </div>

    )
}

export default DynamicsChart;